import { render, staticRenderFns } from "./buttonPersonQuick.vue?vue&type=template&id=aa709b1e&"
import script from "./buttonPersonQuick.vue?vue&type=script&lang=js&"
export * from "./buttonPersonQuick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports